import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport } from "vue"

import {useCookies, useTranslation} from '@malt/vue3-use';

    const cookieName = 'country-launching-banner';
    
export default /*#__PURE__*/_defineComponent({
  __name: 'CountryLaunchingBanner',
  setup(__props) {

    const {countryLaunchingBanner} = useCookies([cookieName]);

    const displayBanner = window.features.maltLaunchingBanner && !countryLaunchingBanner;

    const countryFlags: Record<string, string> = {
        AE: '🇦🇪',
        AT: '🇦🇹',
        BE: '🇧🇪',
        CH: '🇨🇭',
        DE: '🇩🇪',
        DK: '🇪🇺',
        ES: '🇪🇸',
        FR: '🇫🇷',
        HU: '🇭🇺',
        NL: '🇳🇱',
        PT: '🇵🇹',
        UK: '🇬🇧',
        GB: '🇬🇧',
    };

    const {countryCode, countryName, customerSupportEmail} = window.__NAVBAR_UNLOGGED__;
    const countryFlag = countryFlags[countryCode];

    const {msg} = useTranslation();
    const message = msg('country.launching.banner', countryName, countryFlag, customerSupportEmail);

    function onClick() {
        // Checking if snackbar is still in the DOM. If not, banner was closed.
        const isBannerVisible = document.body.querySelector('[data-testid="country-launching-banner"]');
        if (!isBannerVisible) {
            document.cookie = `${cookieName}=seen;path=/`;
        }
    }

return (_ctx: any,_cache: any) => {
  const _component_joy_snackbar = _resolveComponent("joy-snackbar")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_unref(displayBanner))
      ? (_openBlock(), _createBlock(_component_joy_snackbar, {
          key: 0,
          "data-testid": "country-launching-banner",
          class: "new-country-snackbar",
          "dangerous-html-message": _unref(message),
          duration: "forever",
          closable: "",
          onClick: onClick
        }, null, 8, ["dangerous-html-message"]))
      : _createCommentVNode("", true)
  ]))
}
}

})